export { ConnexionInfosGamepad } from './connexion_infos';
export { ConnexionInfosGamepad2 } from './connexion_infos2';

export { ConditionalConnexionInfos } from './conditional_connexion_infos';